import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import default CSS for Toastify
import './CustomToastStyles.css'; // Import custom styles
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

const AddUser = () => {
    const [formData, setFormData] = useState({
        bmid: '',
        name: '',
        user_type: '',
        dept: ''
    });
    const navigate = useNavigate();

    const validateFormData = () => {
        const { bmid, name, user_type, dept } = formData;
        if (!bmid || !name || !user_type || !dept) {
            toast.error('All fields are required');
            return false;
        }
        return true;
    };

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFormData()) return;

        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key] !== null && formData[key] !== '') {
                formDataToSubmit.append(key, formData[key]);
            }
        });

        try {
            const token = localStorage.getItem('authToken');

            const response = await fetch('${API_BASE_URL}postUsers', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formDataToSubmit
            });

            const result = await response.json();

            if (result.status) {
                toast.success('Item successfully added');
                setFormData({
                    bmid: '',
                    name: '',
                    user_type: '',
                    dept: ''
                });
                navigate('/manage_user');
            } else {
                toast.error(result.message || 'An error occurred while adding the user.');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            toast.error('Failed to submit form');
        }
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed">
            <div className="wrapper">

                <Header />
                <Sidebar />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Add User</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Add User</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="col-lg-12">
                        <div className="card" style={{ borderTop: '3px solid #00c0ef' }}>
                            <div className="box box-info">
                                <div className="card-header">
                                    <h3 className="card-title">Add User</h3>
                                </div>

                                <div className="card-body">
                                    <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                        <div className="box-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="bmid">(BMID)<span style={{ color: 'red' }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            name="bmid"
                                                            id="bmid"
                                                            value={formData.bmid}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            placeholder="BMID"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="name">Name<span style={{ color: 'red' }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            placeholder="Name"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="user_type">
                                                            Is Admin<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <select
                                                            name="user_type"
                                                            id="user_type"
                                                            value={formData.user_type}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            required
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Y">Yes</option>
                                                            <option value="N">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="dept">
                                                            Dept<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <select
                                                            name="dept"
                                                            id="dept"
                                                            value={formData.dept}
                                                            onChange={handleChange}
                                                            className="form-control"
                                                            required
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="IT">IT</option>
                                                            <option value="Accounts">Accounts</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="box-footer">
                                            <button type="submit" className="btn btn-success pull-right">Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />

                <aside className="control-sidebar control-sidebar-dark">
                </aside>

            </div>

            {/* Toast Container */}
            <ToastContainer />
        </div>
    );
};

export default AddUser;
